export function getCanvasFontFacesCore(
  Inter: string,
  InterMedium: string,
  NotoSansSC: string,
  NotoSansSCMedium: string,
  NotoSansJP: string,
  NotoSansJPMedium: string,
) {
  let ja = false;
  let isMac = true;

  try {
    ja = self.window && document.body.getAttribute('lang') === 'ja';
  } catch (_) {}

  try {
    isMac = navigator.userAgent.indexOf('Mac') !== -1;
  } catch (_) {}

  const fontFaces = [
    {
      family: 'Inter',
      source: `url(${Inter}) format('woff2')`,
      descriptors: {
        style: 'normal',
        weight: '400',
        display: 'swap',
      },
    },
    {
      family: 'Inter',
      source: `url(${InterMedium}) format('woff2')`,
      descriptors: {
        style: 'normal',
        weight: '500',
        display: 'swap',
      },
    },
  ];

  if (!isMac) {
    // 非mac没有ping fang，使用 Noto Sans
    fontFaces.push(
      ...[
        {
          family: 'Noto Sans SC',
          source: `url(${NotoSansSC}) format('opentype')`,
          descriptors: {
            style: 'normal',
            weight: '400 450',
            display: 'swap',
          },
        },
        {
          family: 'Noto Sans SC',
          source: `url(${NotoSansSCMedium}) format('opentype')`,
          descriptors: {
            style: 'normal',
            weight: '500 550',
            display: 'swap',
          },
        },
      ],
    );

    if (ja) {
      fontFaces.push(
        ...[
          {
            family: 'Noto Sans JP',
            source: `url(${NotoSansJP}) format('opentype')`,
            descriptors: {
              style: 'normal',
              weight: '400 450',
              display: 'swap',
            },
          },
          {
            family: 'Noto Sans JP',
            source: `url(${NotoSansJPMedium}) format('opentype')`,
            descriptors: {
              style: 'normal',
              weight: '500 550',
              display: 'swap',
            },
          },
        ],
      );
    }
  }
  return fontFaces;
}
